// extracted by mini-css-extract-plugin
export default {"wrapper":"DiSf0__wrapper","chkBox":"BJsJW__chkBox","btnNew":"gEV0I__btnNew","name":"MfZfh__name"};